import { isElement } from 'react-is';
import wrapValidator from '../wrapValidator';

var getDisplayName = function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' ? Component : 'Component');
};

var isSymbol = function isSymbol(propType, propValue) {
  if (propType === 'symbol') {
    return true;
  }

  if (propValue['@@toStringTag'] === 'Symbol') {
    return true;
  }

  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
    return true;
  }

  return false;
};

var getPropType = function getPropType(propValue) {
  var propType = typeof propValue;

  if (Array.isArray(propValue)) {
    return 'array';
  }

  if (propValue instanceof RegExp) {
    return 'object';
  }

  if (isSymbol(propType, propValue)) {
    return 'symbol';
  }

  return propType;
};

var elementOfTypeValidator = function elementOfTypeValidator(ExpectedElementType) {
  var loose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var validator = function validator(props, propName, componentName, location, propFullName) {
    var prop = props[propName];
    var expectedElementTypeName = getDisplayName(ExpectedElementType);
    var propType = getPropType(prop);

    if (loose && (propType === 'undefined' || prop === null || prop === false)) {
      return null;
    }

    if (propType !== 'object') {
      return "Invalid ".concat(location, " `").concat(propFullName, "` of type ") + "`".concat(propType, "` supplied to `").concat(componentName, "`, expected ") + "element of type `".concat(expectedElementTypeName, "`.");
    }

    var type = prop && prop.type;
    var isFunctionalComponent = type && !type.prototype.render;
    var isCorrectType;

    if (!isFunctionalComponent) {
      isCorrectType = type && (type === ExpectedElementType || type.prototype instanceof ExpectedElementType);

      if (!isCorrectType && type) {
        isCorrectType = !!type.WrappedComponent;
      }
    } else {
      isCorrectType = isElement(prop);
    }

    if (prop && !isCorrectType) {
      if (!type) {
        return "Invalid ".concat(location, " `").concat(propFullName, "` with value ") + "`".concat(JSON.stringify(prop), "` supplied to `").concat(componentName, "`, expected ") + "element of type `".concat(expectedElementTypeName, "`.");
      }

      var actualElementTypeName = getDisplayName(type);
      return "Invalid ".concat(location, " `").concat(propFullName, "` of element type ") + "`".concat(actualElementTypeName, "` supplied to `").concat(componentName, "`, expected ") + "element of type `".concat(expectedElementTypeName, "`.");
    }

    return null;
  };

  return wrapValidator(validator);
};

export default elementOfTypeValidator;